import { Helmet } from "react-helmet"
import { FormAuth } from "../../components/authForm/authForm"

export const Login = () => {
    return (
        <>
            <Helmet>
                <title>SHOP.CO | Login - Access Your Account</title>
                <meta
                    name="description"
                    content="Log in to your SHOP.CO account to track orders, manage your shopping preferences, and enjoy a personalized shopping experience."
                />

                <link
                    rel="canonical"
                    href="https://shop-co-roan.vercel.app/login/"
                />
            </Helmet>

            <FormAuth title="Login" fields={["email", "password"]} endPoint="login" buttonName="Login" />
        </>
    )
}